module.exports = __webpack_public_path__ + "img/location-default.10c4fc21.svg";